import { TOP_GAMES_CATEGORY_ID } from '@/consts/topGamesCategory';
import { MARKET_LOCALES } from '@/libs/market/market';

export const LOCALES = [MARKET_LOCALES.US, MARKET_LOCALES.CA] as const;

// Keep build artifacts bounded: CA remains a supported dynamic/ISR locale, while only
// the default US locale is expanded across every SEO route during `next build`.
export const PREGENERATED_LOCALES = [MARKET_LOCALES.US] as const;

export const LANGUAGE_LABELS: Record<string, string> = {
  [MARKET_LOCALES.US]: 'English (United States)',
  [MARKET_LOCALES.CA]: 'English (Canada)',
};

export const LANGUAGE_OPTIONS = LOCALES.map(locale => ({
  value: locale,
  label: LANGUAGE_LABELS[locale] || locale,
}));

export const localePrefix = {
  mode: 'as-needed',
  prefixes: {
    [MARKET_LOCALES.CA]: '/ca',
  },
} as const;

export const nextIntlConfig = {
  locales: [...LOCALES] as const,
  defaultLocale: MARKET_LOCALES.US,
  localePrefix,
  // Market comes from the explicit URL or authenticated user.market, not Accept-Language.
  localeDetection: false,
  // A next-intl preference must not override the backend market or fragment CDN routing.
  localeCookie: false,
  // pathnames,
  alternateLinks: false,
};

export const AppRoutes = {
  home: '/',
  gameBase: '/game',
  gamesId: (id: string) => `/game/${id}`,
  profile: '/profile',

  categoryId: (categoryId: string) => `/category/${categoryId}`,
  categoryIdPaged: (categoryId: string, page = 1) => page <= 1 ? `/category/${categoryId}` : `/category/${categoryId}/${page}`,

  // seo routes
  slots: '/slots',
  slotsSlug: (slugOrId: string) => `/slots/${slugOrId}`,

  categories: '/categories',
  categoriesSlug: (slugOrId: string) => `/categories/${slugOrId}`,
  categoriesSlugPaged: (slugOrId: string, page = 1) => page <= 1 ? `/categories/${slugOrId}` : `/categories/${slugOrId}/${page}`,

  providers: '/providers',
  providersSlug: (slugOrId: string) => `/providers/${slugOrId}`,
  providersSlugPaged: (slugOrId: string, page = 1) => page <= 1 ? `/providers/${slugOrId}` : `/providers/${slugOrId}/${page}`,

  install: '/install',
  installSlug: (slug: string) => `/install/${slug}`,

  fairPlay: '/fair-play',
  fairPlayPage: (id: string) => `/fair-play/${id}`,

  gamification: '/gamification',
  gamificationMissions: '/gamification/missions',
  gamificationMissionGames: '/gamification/mission-games',
  gamificationRewards: '/gamification/rewards',
  gamificationFreeSpins: '/gamification/free-spins',
  gamificationLevelUp: '/gamification/level-up',
  gamificationStatusUp: '/gamification/status-up',
  gamificationAllStages: '/gamification/all-statuses',

  referral: '/referral',
  referralInvite: '/referral/invite',
  topGames: `/category/${TOP_GAMES_CATEGORY_ID}`,

  // scratch card pages
  scratchCard: '/scratch-card',
} as const;
